import React from 'react'

import {Col} from 'react-flexbox-grid'

const Column = ({dataTest, ...props }) => {
  return <Col {...props} data-test={dataTest} style={{ paddingLeft: props.paddingLeft ? props.paddingLeft : '16px', paddingRight: props.paddingRight ? props.paddingRight : '16px' }} />
}

export default Column
